module.exports = __webpack_public_path__ + "static/img/Feb-2019-organigrama.83e470c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/organizacion-en/Feb-2019-organigrama.jpg
// module id = OdV2
// module chunks = 0